import { json, postBiz } from '../core/coreapi';
import { BieRecordId } from './bieonboardingworkbench.models';
import {
  normalizeImportId,
  normalizeImportItemId,
} from './bieonboarding.normalize';

const SERVICE = 'bieimportdecision';

export type BieImportDecisionCode = 'KEEP' | 'REPLACE' | 'REVISE';

export interface IBieImportDecisionResult {
  rid?: BieRecordId;
  stp?: string;
  decision?: Record<string, unknown>;
  nextaction?: Record<string, unknown>;
  importid?: BieRecordId;
  selectedcount?: number;
  appliedcount?: number;
  failedcount?: number;
  exactcount?: number;
  results?: unknown[];
}

export async function setBieImportDecision(
  importItemId: BieRecordId,
  decisionCode: BieImportDecisionCode,
  decisionReason: string,
): Promise<IBieImportDecisionResult> {
  return json(await postBiz({
    s: SERVICE,
    a: 'set',
    iti: normalizeImportItemId(importItemId),
    dcc: decisionCode,
    dcr: decisionReason,
  })) as IBieImportDecisionResult;
}

export async function keepExactBieImportDuplicates(
  importId: BieRecordId,
  decisionReason: string,
): Promise<IBieImportDecisionResult> {
  return json(await postBiz({
    s: SERVICE,
    a: 'exactkeep',
    imi: normalizeImportId(importId),
    dcr: decisionReason,
  })) as IBieImportDecisionResult;
}

export async function bulkSetBieImportDecisions(
  importId: BieRecordId,
  importItemIds: BieRecordId[],
  decisionCode: BieImportDecisionCode,
  decisionReason: string,
): Promise<IBieImportDecisionResult> {
  return json(await postBiz({
    s: SERVICE,
    a: 'bulkset',
    imi: normalizeImportId(importId),
    ids: JSON.stringify(importItemIds),
    dcc: decisionCode,
    dcr: decisionReason,
  })) as IBieImportDecisionResult;
}
